import { gql } from '@apollo/client';
/**
 * @const ImportSaleItemVariantOptionsMutation
 * @since 1.0.0
 */
export const ImportSaleItemVariantOptionsMutation = gql `
  mutation ImportSaleItemVariantOptionsMutation($input: ImportSaleItemVariantOptionsInput!) {
    importSaleItemVariantOptions(input: $input)
  }
`;
